import { useSyncExternalStore } from 'react';

// WHETHER THE SCREEN IS A PHONE'S: narrower than Tailwind's `sm`, the breakpoint every
// `max-sm:` class in the app answers to, so a layout chosen here and one chosen in CSS agree.
// For the layouts CSS cannot choose alone, where a component draws different things rather
// than the same things differently.
const QUERY = '(max-width: 639.98px)';

const subscribe = (change: () => void) => {
  const list = window.matchMedia(QUERY);
  list.addEventListener('change', change);
  return () => list.removeEventListener('change', change);
};

export function usePhone() {
  return useSyncExternalStore(subscribe, () => window.matchMedia(QUERY).matches, () => false);
}
